import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import useHashLocation, { currentLocation } from "../use-hash-location";
import store from "../appStore";
import { useSnapshot } from "valtio";

const LangRouteChanger = (props) => {
  const [_, setLocation] = useHashLocation();

  const [ready, setReady] = useState(false);

  const { i18n } = useTranslation();

  const { loadingFinished, languages } = useSnapshot(store);

  useEffect(() => {
    if (languages && languages.length > 0) {
      var location = window.location.hash;

      var urlLang = store.languages.find((l) => location.startsWith(`#/${l.locale}`));

      if (urlLang && i18n.language != urlLang) {
        i18n.changeLanguage(urlLang.locale);
      }
      setReady(true);
    }
  }, [languages]);

  useEffect(() => {
    if (ready && loadingFinished) {
      let loc = currentLocation();

      //HACK
      setLocation("");
      setLocation(loc);
    }
  }, [ready, loadingFinished]);

  return null;
};

export default LangRouteChanger;
